/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class CorrectionController implements angular.IController {
        public attachment: File[];
        public isSending: boolean;
        public fileAccessToken: string;
        public canvas: FloorplanCanvasModel;
        public comment: string;
        public user: UserModel;
        public currentItem: CorrectionItemViewModel;
        public zoomFactor: number;
        $onInit = () => { };
        constructor(private $scope: any,
            private $mdDialog: any,
            private floorplan: FloorplanViewModel,
            private correctionId: string,
            private $timeout: ng.ITimeoutService,
            private $sce: ng.ISCEService,
            private floorplanService: FloorPlanService,
            private fileService: FileService,
            private userService: UserService,
            private correction: CorrectionViewModel,
            private $rootScope: ng.IRootScopeService,
            private textService: TextService
        ) {
            var vm = this;
            this.zoomFactor = 1;
            this.canvas = new FloorplanCanvasModel('canvasContainer', this.canEdit(), () => {
                vm.$timeout(() => {
                    vm.correction.correctionItems.forEach((value) => value.active = false);
                    vm.currentItem = null;
                });
            }, () => vm.zoomFactor, (item: CorrectionItemViewModel) => {
                    vm.$timeout(() => {
                        vm.correction.correctionItems.forEach((value) => value.active = false);
                        if (vm.currentItem != null) {
                            vm.currentItem.locationX = item.locationX;
                            vm.currentItem.locationY = item.locationY;
                            vm.currentItem.width = item.width;
                            vm.currentItem.rotationAngle = item.rotationAngle;
                        }
                        else {
                            item.active = true;
                            vm.currentItem = item;
                            vm.correction.correctionItems.push(item);
                        }
                }).then(() => setTimeout(() => {
                    if (item == null || item.correctionType == null) {
                        return;
                    }
                    if (item.correctionType.toString() == CorrectionType[CorrectionType.edit].toString()) {
                        $('#canvasContainer .pen:last').focus();
                    }
                    else if (item.correctionType.toString() == CorrectionType[CorrectionType.arrow].toString()) {
                        $('#canvasContainer .arrow:last .title').focus();
                    }
                    else {
                        $('#canvasContainer .correction:last .title').focus();
                    }
                }, 100));

            }, $timeout);
            this.attachment = [];
            this.userService.getUser().then((user: UserModel) => vm.user = user);
            fileService.getFileToken().then((token: string) => vm.fileAccessToken = token);
            this.$scope.fileSelected = function (sender) {
                vm.$timeout(() => {
                    vm.attachment = [];
                    for (var i = 0; i < sender.files.length; i++) {
                        vm.attachment.push(sender.files[i]);
                    }
                });
            }
            this.$scope.closeDialog = function (statusItem) {
                if (vm.canEdit()) {
                    vm.canvas.unsubscribeEvents(FloorplanChangelogStatusItem);
                }
                vm.isSending = false;
                vm.$mdDialog.hide(statusItem);
            };

            if (this.correction == null) {
                if (correctionId != null) {
                    this.floorplanService.getById(correctionId).then((data: CorrectionViewModel) => {
                        vm.correction = data;
                    });
                }
                else if (floorplan.hasCorrection) {
                    floorplanService.getCorrection(floorplan.associationNumber, floorplan.departmentNumber, floorplan.housingNumber).then((data: CorrectionViewModel) => {
                        vm.correction = data;
                    }, () => {
                        vm.showAlert('Unauthorized', 'You do not have permissions for this action.');
                        vm.$mdDialog.cancel();
                    });
                }
                else {
                    this.correction = new CorrectionViewModel();
                    this.correction.companyNumber = floorplan.companyNumber;
                    this.correction.association = floorplan.associationNumber;
                    this.correction.department = floorplan.departmentNumber;
                    this.correction.localizer = floorplan.localizer;
                    this.correction.sheetNumber = floorplan.housingNumber;
                    this.correction.images = floorplan.urls.filter(u => !vm.ignoreUrl(u)).sort(vm.sortUrls).map(u => new CorrectionImageViewModel(!!u.alternativeUrl ? u.alternativeUrl : u.url));
                }
            }
        }

        public getFloorplanNumber() {
            if (this.floorplan != null) {
                return this.floorplan.associationNumber + " - " + this.floorplan.departmentNumber + ' - ' + this.floorplan.housingNumber;
            }
            else if (this.correction != null) {
                return this.correction.association + " - " + this.correction.department + ' - ' + this.correction.sheetNumber;
            }
        }

        public getIcon(correctionType: string) {
            return this.$sce.trustAsHtml(CorrectionItemViewModel.icons[CorrectionType[correctionType]]);
        }

        public iconClick($event: any, correction: CorrectionItemViewModel) {
            if ($event.target == null || !this.canEdit()) {
                return;
            }
            if (!$($event.target).hasClass('touchend')) {
                return;
            }
            $($event.target).removeClass('touchend')
            var dragElement = $($event.target).hasClass('pen') || $($event.target).hasClass('arrow') ? $event.target : (<HTMLElement>$event.target).parentElement;
            this.currentItem = correction;
            this.$timeout(() => {
                correction.active = true;
                if (correction.correctionType.toString() == CorrectionType[CorrectionType.edit]) {
                    correction.locationX = dragElement.offsetLeft / this.zoomFactor;
                    correction.locationY = dragElement.offsetTop / this.zoomFactor;
                }
                else if (correction.correctionType.toString() == CorrectionType[CorrectionType.arrow]) {
                    correction.locationX = (dragElement.offsetLeft - 5) / this.zoomFactor;
                    correction.locationY = dragElement.offsetTop / this.zoomFactor;
                }
                else {
                    correction.locationX = (dragElement.offsetLeft + 60) / this.zoomFactor;
                    correction.locationY = (dragElement.offsetTop + 13) / this.zoomFactor;
                }
            });
        }

        public arrayIndexOf(collection: any[], verification: Function) {
            var idx = -1;
            for (var i = 0; i < collection.length; i++) {
                if (verification(collection[i]))
                {
                    return i;
                }
            }
            return idx;
        }

        public deleteItem() {
            var idx = this.arrayIndexOf(this.correction.correctionItems, (it: CorrectionItemViewModel) => it.active);
            if (idx > -1) {
                this.correction.correctionItems.splice(idx, 1);
                this.currentItem = null;
            }
        }

        public iconMouseDown($event: MouseEvent, correction: CorrectionItemViewModel) {
            if ($event.target == null || !this.canEdit()) {
                return;
            }
            this.$timeout(() => {
                correction.active = true;
                this.currentItem = correction;
            });
        }

        public titleKeypress(event: KeyboardEvent) {
            if (event.keyCode == 27) {
                $(event.target).blur();
            }
        }

        public titleBlur($event: any, item: CorrectionItemViewModel) {
            if ($event.target != null) {
                var vm = this;
                this.$timeout(() => {
                    item.text = $event.target.innerHTML;
                });
            }
        }

        public attachFile() {
            jQuery('#fpCorrectionUpload').click();
        }

        public deleteAttachment(file: File) {
            var confirm = this.$mdDialog.confirm()
                .title(this.textService.translate('General_DeleteFile'))
                .textContent(this.textService.translate('General_DeleteConfirmation').replace(/\{0\}/g, file.name))
                .ariaLabel(this.textService.translate('General_DeleteFile'))
                .ok(this.textService.translate('Button_OK'))
                .cancel(this.textService.translate('Button_Cancel'))
                .multiple(true);

            return this.$mdDialog.show(confirm).then(() => {
                var idx = this.attachment.indexOf(file);
                if (idx > -1) {
                    this.attachment.splice(idx, 1);
                }
            }, () => { });
        }

        public getTrustedHtml(val: string) {
            return this.$sce.trustAsHtml(val);
        }

        public canEdit() {
            if (this.floorplan != null) {
                return this.correctionId == null && this.floorplan != null && (!this.floorplan.hasCorrection || this.floorplan.canEditCorrection);
            }
            else {
                return this.correction != null && this.correction.canEdit && !this.correction.isClosed && this.correction.status != 'Completed';
            }
        }

        public commentKeyDown(e: KeyboardEvent) {
            if (e.keyCode == 13 && !e.shiftKey && this.comment != null && this.comment != '') {
                e.stopImmediatePropagation();
                e.stopPropagation();
                e.preventDefault();
                this.addComment();
            }
        }

        public addComment() {
            var vm = this;
            if (this.correction.id == null) {
                var newComment = new CorrectionCommentViewModel();
                newComment.userName = vm.user.name;
                newComment.text = this.comment.replace(/\n/g, '<br/>');
                var found = false;
                for (var c of vm.correction.comments) {
                    if (c.dateAsString == 'Today') {
                        if (c.comments.length > 0 && c.comments[c.comments.length - 1].userName == vm.user.name) {
                            c.comments[c.comments.length - 1].text += '<br/>' + newComment.text;
                        }
                        else {
                            c.comments.push(newComment);
                        }
                        found = true;
                    }
                }
                if (!found) {
                    var cbd = new CorrectionCommentsByDate();
                    cbd.dateAsString = 'Today';
                    cbd.comments.push(newComment);
                    vm.correction.comments.push(cbd);
                }
                if (vm.correction.newComments == null) {
                    vm.correction.newComments = [];
                }
                if (vm.correction.newComments.length > 0 && vm.correction.newComments[vm.correction.newComments.length - 1].userName == vm.user.name) {
                    vm.correction.newComments[vm.correction.newComments.length - 1].text += vm.comment.replace(/\n/g, '<br/>');
                }
                else {
                    vm.correction.newComments.push(newComment);
                }
                this.comment = '';
            }
            else {
                this.floorplanService.addComment(this.correction.id, this.comment.replace(/\n/g, '<br/>')).then((comments: CorrectionCommentsByDate[]) => {
                    vm.correction.comments = comments;
                    vm.comment = '';
                },
                    (rejection) => {
                        switch (rejection.status) {
                            case 401:
                                vm.showAlert('Unauthorized', 'You do not have permissions for this action.');
                                break;
                            default:
                                vm.showAlert('Error', 'Internal error has occured while saving data.');
                                break;
                        }
                    });
            }
        }

        public save() {
            var vm = this;
            if (!this.canEdit() || this.isSending) {
                return;
            }
            if (vm.correction.createdByEmail != null && vm.correction.createdByEmail != '') {
                var confirm = this.$mdDialog.confirm()
                    .title(this.textService.translate('Floorplan_EditCorrectionWarningTitle'))
                    .textContent(this.textService.translate('Floorplan_EditCorrectionWarningText'))
                    .ariaLabel(this.textService.translate('Floorplan_EditCorrectionWarningTitle'))
                    .ok(this.textService.translate('Button_OK'))
                    .cancel(this.textService.translate('Button_Cancel'))
                    .multiple(true);
                var vm = this;

                this.$mdDialog.show(confirm).then(() => {
                    vm.doSave();
                }, () => { });
            }
            else {
                vm.doSave();
            }
        }

        public doSave() {
            var vm = this;
            vm.isSending = true;
            vm.floorplanService.saveCorrection(vm.correction).then((statusItem: FloorplanChangelogStatusItem) => {
                if (vm.attachment != null && vm.attachment.length > 0) {
                    var data = new FormData();
                    angular.forEach(vm.attachment, function (value) {
                        data.append("files[]", value);
                    });
                    vm.floorplanService.uploadAttachment(vm.floorplan.associationNumber, vm.floorplan.departmentNumber, vm.floorplan.housingNumber, data).then(() => {
                        vm.$scope.closeDialog(statusItem);
                    },
                        (rejection) => {
                            switch (rejection.status) {
                                case 401:
                                    vm.showAlert('Unauthorized', 'You do not have permissions for this action.');
                                    break;
                                default:
                                    vm.showAlert('Error', 'Internal error has occured while saving data.');
                                    break;
                            }
                        });
                }
                else {
                    vm.$scope.closeDialog(statusItem);
                }
                vm.$rootScope.$broadcast('correction-saved');
                if (vm.floorplan != null) {
                    vm.$timeout(() => {
                        if (vm.floorplan.hasCorrection) {
                            vm.floorplan.isModified = true;
                        }
                        vm.floorplan.canEditCorrection = !vm.floorplan.hasCorrection;
                        vm.floorplan.hasCorrection = true;
                    });
                }
            },
                (rejection) => {
                    vm.isSending = false;
                    switch (rejection.status) {
                        case 401:
                            vm.showAlert('Unauthorized', 'You do not have permissions for this action.');
                            break;
                        default:
                            vm.showAlert('Error', 'Internal error has occured while saving data.');
                            break;
                    }
                }
            );
        }

        public zoomIn() {
            if (this.zoomFactor < 2) {
                this.zoomFactor += 0.25;
            }
        }

        public zoomOut() {
            if (this.zoomFactor > 0.5) {
                this.zoomFactor -= 0.25;
            }
        }

        public deleteOldAttachment(file: CorrectionAttachmentViewModel) {
            var confirm = this.$mdDialog.confirm()
                .title(this.textService.translate('General_DeleteFile'))
                .textContent(this.textService.translate('General_DeleteConfirmation').replace(/\{0\}/g, file.fileName))
                .ariaLabel(this.textService.translate('General_DeleteFile'))
                .ok(this.textService.translate('Button_OK'))
                .cancel(this.textService.translate('Button_Cancel'))
                .multiple(true);

            return this.$mdDialog.show(confirm).then(() => {
                var idx = this.correction.attachments.indexOf(file);
                if (idx > -1) {
                    this.$timeout(() => this.correction.attachments.splice(idx, 1));
                }
            }, () => { });
        }

        public ignoreUrl(url: FloorplanUrlViewModel) {
            return url.is3D || url.isPdf || url.url.toLowerCase().indexOf('_alt') > -1 || url.url.toLowerCase().indexOf('furniture') > -1;
        }

        private sortUrls(url1: FloorplanUrlViewModel, url2: FloorplanUrlViewModel) {
            if (url1.fileName < url2.fileName)
                return -1;
            if (url1.fileName > url2.fileName)
                return 1;
            return 0;
        }

        private showAlert(title: string, message: string) {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(message)
                    .ok('OK')
            );
        }
    }

    export class ImageSize {
        public constructor(public width: number, public height: number){}
    }

    CorrectionController.$inject = ['$scope', '$mdDialog', 'floorplan', 'correctionId', '$timeout', '$sce', 'FloorPlanService', 'FileService', 'UserService', 'correction', '$rootScope', 'TextService'];

    angular
        .module('eseebase')
        .controller('CorrectionController', CorrectionController);
}
